import {KTIcon} from '../../../../_metronic/helpers'

function NoChat() {
  return (
    <div
      style={{backgroundColor: '#fff', boxShadow: '0px 0px 130px 0px rgb(236 225 237 / 80%) inset'}}
      className="h-100 d-flex justify-content-center align-items-center flex-column rounded-end border-start border-gray-200"
    >
      <KTIcon iconName="messages" className="fs-7hx" />
      <div className="fs-1 lead">Your message center!</div>
      <div className="fs-4 text-gray-600">
        Keep parents informed with accurate updates and notices.
      </div>
    </div>
  )
}

export default NoChat
